import { environment } from '../../../../environments/environment';

const BASE_ONBOARDING_URL = `${environment.muleExperienceBaseURI}`;

export const PARTY_ONBOARDING_SERVICE_API_ROUTES = {
	partyOnboardingExecution: () =>
		`${BASE_ONBOARDING_URL}/party-onboarding/executions`,
	deletePartyOnboardingExecution: (executionId: string) =>
		`${BASE_ONBOARDING_URL}/party-onboarding/executions/${executionId}`,
	submitPartyOnboardingExecution: (executionId: string) =>
		`${BASE_ONBOARDING_URL}/party-onboarding/executions/${executionId}/submit`
};
